export const FilterType = {
    NoOfDays: 'noOfDays',
    AssetId: 'orderId',
    Type: 'type',
} as const;

export type FilterType = (typeof FilterType)[keyof typeof FilterType];
